<template>
  <div class="content-wrap">
    <div class="card-header">
      <h3 class="title"></h3>
      <el-button type="primary"
                 @click="handleResourceAdd">添加讲义</el-button>
    </div>
    <div class="table-wrap">
      <el-table ref="table"
                :data="results"
                style="width: 100%;"
                row-key="id"
                row-class-name="row-item">
        <el-table-column prop="id"
                         label="讲义ID"
                         width="150">
          <template slot-scope="scope">
            <span>{{scope.row.id ? scope.row.id  : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         label="讲义名称"
                         min-width="300">
          <template slot-scope="scope">
            <span>{{scope.row.name ? scope.row.name  : ''}}</span> <span style="color:red"
                  v-if="!scope.row.resource">（文件缺失请重新上传）</span>
          </template>
        </el-table-column>

        <el-table-column prop="description"
                         label="讲义说明"
                         min-width="300">
        </el-table-column>
        <el-table-column label="讲义类型"
                         min-width="200"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type ==  1">图文</span>
            <span v-else>{{scope.row.resource ? scope.row.resource.mime_type  :''}}</span>
            <!-- <span>{{scope.row.type ==  1 ? '图文' : (scope.row.resource.mime_type || '')}}</span> -->
          </template>
        </el-table-column>
        <el-table-column class-name="action-cell"
                         label="操作"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            <div class="menu-wrap">
              <div v-if="handleActionCheck(scope.row, 'up')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'up')">上移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="handleActionCheck(scope.row, 'down')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'down')">下移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handleChapterToEdit(scope.row)">编辑</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handleRemoveResource(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CourseResourceCreate :visible="createDialog"
                          @close="createDialog = false"
                          @submit="fetchCoursePaperList"></CourseResourceCreate>
    <CourseResourceEdit :visible="editDialog"
                        :content="editRow"
                        @close="editDialog = false"
                        @submit="fetchCoursePaperList"></CourseResourceEdit>
  </div>
</template>

<script>
import CourseResourceCreate from '@/components/dialog/course/CourseResourceCreate'
import CourseResourceEdit from '@/components/dialog/course/CourseResourceEdit'
import {
  courseResourceList,
  courseResourceCreate,
  courseResourceUpdate,
  courseResourcesUpdate,
  courseResourceDestroy,
} from '@/api/course'

export default {
  components: {
    CourseResourceCreate,
    CourseResourceEdit,
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      results: [],
    }
  },
  created() {
    this.fetchCoursePaperList()
  },
  methods: {
    // 随堂练习列表请求
    fetchCoursePaperList() {
      courseResourceList({ product_id: this.$route.params.courseId }).then(
        (res) => {
          this.results = res.list || []
          console.log(' this.results ', this.results)
        }
      )
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      let { index, list } = this.computeIndex(row.id)
      let item = list.splice(index, 1)[0]
      if (sort == 'up') {
        list.splice(index - 1, 0, item)
      } else if (sort == 'down') {
        list.splice(index + 1, 0, item)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      courseResourcesUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节排序更新异常')
          console.log('error: ', error)
        })
    },
    // 删除章节
    handleRemoveResource(row) {
      let { index, list } = this.computeIndex(row.id)
      courseResourceDestroy({ id: row.id })
        .then((res) => {
          list.splice(index, 1)[0]
        })
        .catch((error) => {
          this.$message.error('讲义删除失败')
          console.log('error: ', error)
        })
    },
    // 数据位置计算
    computeIndex(id) {
      let index = null
      let length = 0
      let list = []
      this.results.some((item, i, arr) => {
        if (item.id == id) {
          index = i
          length = this.results.length
          list = arr
          return true
        }
      })
      return { index, length, list }
    },
    // 排序边界检查
    handleActionCheck(row, type) {
      let { index, length } = this.computeIndex(row.id)
      if (type == 'up') {
        if (index === 0) {
          return false
        }
        if (index > 0 && length > 1) {
          return true
        }
      }
      if (type == 'down') {
        if (index === length - 1) {
          return false
        }
        return true
      }
      return false
    },
    // 章节编辑
    handleChapterToEdit(row) {
      this.editRow = row
      this.editDialog = true
    },
    // 添加讲义
    handleResourceAdd() {
      this.createDialog = true
    },
  },
}
</script>

<style scoped lang="less">
.content-wrap {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .table-wrap {
    /deep/ .action-cell {
      .el-divider--vertical {
        margin: 0 4px;
      }
    }

    /deep/ .row-item {
      .menu-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
